import PlatformTenants from "@/views/platform/tenants.vue"
import PlatformTenantRenewal from "@/views/platform/tenant-renewal.vue"
import PlatformTenantLogs from "@/views/platform/tenant-logs.vue"
import VersionControl from "@/views/system/version.vue"

/** 超管后台菜单与页面路由（挂载在 /platform 下） */
export const platformRoutes = [
  {
    path: "tenants",
    name: "platformTenants",
    title: "租户信息",
    icon: "OfficeBuilding",
    permission: "platform",
    component: PlatformTenants,
    meta: { portal: "platform", title: "租户信息" },
  },
  {
    path: "tenant-renewal",
    name: "platformTenantRenewal",
    title: "租户续期",
    icon: "Calendar",
    permission: "platform",
    component: PlatformTenantRenewal,
    meta: { portal: "platform", title: "租户续期" },
  },
  {
    path: "tenant-logs",
    name: "platformTenantLogs",
    title: "开通记录",
    icon: "List",
    permission: "platform",
    component: PlatformTenantLogs,
    meta: { portal: "platform", title: "开通记录" },
  },
  {
    path: "version",
    name: "platformVersionControl",
    title: "版本控制",
    icon: "Promotion",
    permission: "platform",
    component: VersionControl,
    meta: { portal: "platform", title: "版本控制" },
  },
]

/** 侧边栏/子菜单使用的完整路径 */
export function resolvePlatformMenuPath(routeItem) {
  if (!routeItem?.path) {
    return "/platform/tenants"
  }
  if (routeItem.path.startsWith("/")) {
    return routeItem.path
  }
  return `/platform/${routeItem.path}`
}
